// QA check with HW

import {UserDetailsMinRes} from '../cp';
import {Type} from 'class-transformer';
import {LicenseType} from '../../../enums/license-type';
import {LicensePeriod} from '../../../enums/license-period';
import {DeviceDataResponse} from './device-data.contracts';
import {FileUploadRes} from '@yasc/yasc-material-components';

export class LicenseDataResponse {
    public readonly guid!: string;
    public readonly createdAt!: Date;
    public readonly updatedAt!: Date;
    @Type(() => UserDetailsMinRes)
    public readonly createdBy: UserDetailsMinRes[] = [];
    @Type(() => UserDetailsMinRes)
    public readonly updatedBy: UserDetailsMinRes[] = [];
    public readonly licenseId!: string;
    public licenceValid!: boolean;
    public licenseType!: LicenseType;
    public licensePeriod!: LicensePeriod;
    public productName!: string;
    public productVersion!: string;
    public productDescription!: string;
    public licenceStart!: Date;
    public licenceExpires!: Date;
    public autoRenewEnabled!: boolean;
    public userAllowed!: number;
    @Type(() => UserDetailsMinRes)
    public userAssigned: UserDetailsMinRes[] = [];
    public userLeft!: number; // backend calculated
    public devicesAllowed!: number;
    @Type(() => DeviceDataResponse)
    public devicesAssigned: DeviceDataResponse[] = [];
    public devicesLeft!: number; // backend calculated
    public licenseKey!: string;
    public fallbackProductVersion!: string;
    public terminationPeriod!: number;
    public terminationDate!: Date;
    public licenseCost!: number;
    public licenseCostPerUserYear!: number; // backend calculated
    @Type(() => FileUploadRes)
    public attachmentList: FileUploadRes[] = [];

    public clone(response: LicenseDataResponse): LicenseDataResponse {
        let responseClone = new LicenseDataResponse();

        responseClone.licenceValid = response.licenceValid;
        responseClone.licenseType = response.licenseType;
        responseClone.licensePeriod = response.licensePeriod;
        responseClone.productName = response.productName;
        responseClone.productVersion = response.productVersion;
        responseClone.productDescription = response.productDescription;
        responseClone.licenceStart = response.licenceStart;
        responseClone.licenceExpires = response.licenceExpires;
        responseClone.autoRenewEnabled = response.autoRenewEnabled;
        responseClone.userAllowed = response.userAllowed;
        responseClone.userAssigned = response.userAssigned;
        responseClone.devicesAllowed = response.devicesAllowed;
        responseClone.devicesAssigned = response.devicesAssigned;
        responseClone.licenseKey = response.licenseKey;
        responseClone.fallbackProductVersion = response.fallbackProductVersion;
        responseClone.terminationPeriod = response.terminationPeriod;
        responseClone.terminationDate = response.terminationDate;
        responseClone.licenseCost = response.licenseCost;
        responseClone.attachmentList = response.attachmentList;

        return responseClone;
    }
}

export class LicenseDataRequest {
    public guid?: string;
    public createdAt?: Date;
    public updatedAt?: Date;
    public createdBy?: number[] = [];
    public updatedBy?: number[] = [];
    public licenseId?: string;
    public licenceValid?: boolean;
    public licenseType?: LicenseType;
    public licensePeriod?: LicensePeriod;
    public productName?: string;
    public productVersion?: string;
    public productDescription?: string;
    public licenceStart?: Date;
    public licenceExpires?: Date;
    public autoRenewEnabled?: boolean;
    public userAllowed?: number;
    public userAssigned?: number[] = [];
    public devicesAllowed?: number;
    public devicesAssigned?: string[] = [];
    public licenseKey?: string;
    public fallbackProductVersion?: string;
    public terminationPeriod?: number;
    public terminationDate?: Date;
    public licenseCost?: number;
    public attachmentList?: string[] = [];

    public fromResponse(response: LicenseDataResponse): LicenseDataRequest {
        let request = new LicenseDataRequest();

        request.guid = response.guid;
        request.createdAt = response.createdAt;
        request.updatedAt = response.updatedAt;
        request.createdBy = response.createdBy.map(x => x.id);
        request.updatedBy = response.updatedBy.map(x => x.id);
        request.licenseId = response.licenseId;
        request.licenceValid = response.licenceValid;
        request.licenseType = response.licenseType;
        request.licensePeriod = response.licensePeriod;
        request.productName = response.productName;
        request.productVersion = response.productVersion;
        request.productDescription = response.productDescription;
        request.licenceStart = response.licenceStart;
        request.licenceExpires = response.licenceExpires;
        request.autoRenewEnabled = response.autoRenewEnabled;
        request.userAllowed = response.userAllowed;
        request.userAssigned = response.userAssigned.map(x => x.id);
        request.devicesAllowed = response.devicesAllowed;
        request.devicesAssigned = response.devicesAssigned.map(x => x.guid);
        request.licenseKey = response.licenseKey;
        request.fallbackProductVersion = response.fallbackProductVersion;
        request.terminationPeriod = response.terminationPeriod;
        request.terminationDate = response.terminationDate;
        request.licenseCost = response.licenseCost;
        request.attachmentList = response.attachmentList.map(x => x.id);

        return request;
    }
}

export class LicenseDataCsvImportRequest {
    mappingId!: number;
    data!: any[];

    constructor(mappingId: number, data: any[]) {
        this.mappingId = mappingId;
        this.data = data;
    }
}
